import * as yup from 'yup';

const converterStringParaNumero = (value, valorOriginal) => {
  if (!valorOriginal && valorOriginal !== 0) {
    return undefined;
  }

  if (typeof valorOriginal === 'string') {
    const valorConvertido = valorOriginal.replace(',', '.');
    const numero = parseFloat(valorConvertido);

    if (!Number.isNaN(numero)) {
      return numero;
    }
  }

  return valorOriginal;
};

export default yup.object().shape({
  categoria:
    yup.string().required('Categoria é requerida'),
  cnpj:
    yup.string().when('categoria', {
      is: 'prospect',
      then: yup.string(),
      otherwise: yup.string().required('Cliente é requerido'),
    }),
  idUsuario:
    yup.number().required(),
  referenciaTrust:
    yup.string(),
  classificacao:
    yup.string().required('Classificação é requerida'),
  regimeApuracao:
    yup.string().required('Regime de Apuraçao é requerido'),
  filiais:
    yup.string().required('Filial é requerida'),
  aplicacao:
    yup.string().required('Aplicação do Produto é requerida'),
  incoterm:
    yup.string().required('Incoterm é requerido'),
  modeloFreteInternacional:
    yup.string().required('Modelo de Frete Internacional é requerido'),
  modalidadeRateio:
    yup.string().required('Modalidade de rateio é requerida'),
  enderecoOrigem:
    yup.string().when('incoterm', {
      is: 'EXW',
      then: yup.string().required('Endereço de Origem é requerido'),
    }),
  portoOrigem:
    yup.string().required('Porto de Origem é requerido'),
  portoDestino:
    yup.string().required('Porto de Destino é requerido'),
  logisticaNacional:
    yup.boolean().nullable().required('Logística Nacional é requerida'),
  enderecoEntrega:
    yup.string().required('Endereço de entrega é requerido'),
  observacoes:
    yup.string(),
  solicitadoPor:
    yup.string().required(),
  produtos:
    yup.array(
      yup.object().shape({
        ncm:
          yup.string()
            .required('NCM é obrigatório.')
            .min(3, 'NCM deve ter no mínimo três caracteres.')
            .max(255),
        descricao:
          yup.string().nullable(),
        nomeProduto:
          yup.string().nullable(),
        unidadeMedida:
          yup.string()
            .required('Unidade de medida é obrigatória.')
            .min(1, 'Unidade de medida deve ter no mínimo um caracter.')
            .max(255, 'Unidade de medida deve ter no máximo 255 caracteres.'),
        quantidade:
          yup.number()
            .required('Quantidade é obrigatória.')
            .positive(),
        valorUnitario:
          yup.number()
            .required('Valor unitário é obrigatório.')
            .positive(),
        moeda:
          yup.string().required('Moeda é obrigatória.'),
        pesoLiquido:
          yup.number()
            .required('Valor unitário é obrigatório.')
            .positive(),
        li:
          yup.string().nullable(),
        ii: yup
          .number()
          .nullable()
          .transform(converterStringParaNumero)
          .typeError('Formato Inválido'),
        ipi: yup
          .number()
          .nullable()
          .transform(converterStringParaNumero)
          .typeError('Formato Inválido'),
        pis: yup
          .number()
          .nullable()
          .transform(converterStringParaNumero)
          .typeError('Formato Inválido'),
        cofins: yup
          .number()
          .nullable()
          .transform(converterStringParaNumero)
          .typeError('Formato Inválido'),
        cofinsCusto: yup
          .number()
          .nullable(),
        icms: yup
          .string(),
        pisSaida: yup
          .number()
          .nullable(),
        cofinsSaida: yup
          .number()
          .nullable(),
        markup: yup
          .number()
          .nullable(),
        desconto: yup
          .number()
          .nullable(),
        _id: yup.lazy((value) => (value ? yup.string() : yup.string().default(null).nullable().strip())),
      }),
    ).required('Campo Requerido').min(1, 'A cotação deve ter ao menos um produto.'),
});
